import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { getHome as getBanner } from '@/two/src/pages/Home/action'
import { getBlogList } from '@api/hernest/blog/blogSlice'
import { routesPath } from '@api/hernest/utils'
import { getRelativeUrl } from '@utils'
import { isMobileProject } from '@utils/index'

export const getUrl = (data: any) => {
  const newTitle = `${data.title
    ?.toLocaleLowerCase()
    .replace(/[^a-zA-Z0-9]/g, '-')}`

  const url = `${routesPath.blogDetail}/${encodeURIComponent(newTitle)}-b-${
    data.id
  }.html`

  return url || ''
}

// pc跳
export const jumpTo = (data: any) => {
  const toUrl = getUrl(data)
  toUrl && window.open(getRelativeUrl(toUrl), '_blank')
}

export const useBlogList = (props?: any) => {
  const navigate = useNavigate()
  const [params, setParams]: any = useState({
    page: 1,
    limit: 8
  })
  const [topBanners, setTopBanners]: any = useState([])
  const [bottomBanners, setBottomBanners]: any = useState([])
  const [blogData, setBlogData]: any = useState({
    list: [],
    pageTotal: 1
  })
  const [moreLoading, setMoreLoading] = useState(false)

  const getBannerList = () => {
    getBanner({ terminal: isMobileProject ? 'm' : 'pc', page: 'blog' }).then(
      (res) => {
        const { banners } = res || {}
        if (banners && Object.keys(banners)?.length) {
          const top: any = banners['1001TopBanner'] || {}
          const bot = banners['1007_1x1BottomBanner']
          setTopBanners(top?.bannersImage || [])
          setBottomBanners(bot?.bannersImage || [])
        }
      }
    )
  }
  const fetchBlogList = (params?: any) => {
    if (moreLoading) {
      return
    }
    getBlogList({ ...params })
      .then((data) => {
        if (data.page === 1) {
          setBlogData(data)
        } else {
          const newList = [...blogData.list, ...data.list]
          setBlogData({
            ...data,
            list: newList
          })
        }
      })
      .finally(() => {
        setMoreLoading(false)
      })
  }

  const loadMore = () => {
    setMoreLoading(true)
    const newPage = blogData.page + 1
    const newParams = {
      ...params,
      page: newPage
    }
    setParams(newParams)
    fetchBlogList(newParams)
  }

  // m跳
  const jumpToM = (data: any) => {
    // const toUrl = getUrl(data)
    // toUrl && navigate(toUrl)
    const toUrl = getUrl(data)
    toUrl && (window.location.href = getRelativeUrl(toUrl))
  }

  useEffect(() => {
    fetchBlogList(params)
    getBannerList()
  }, [])

  return {
    topBanners,
    bottomBanners,
    blogData,
    loadMore,
    moreLoading,
    jumpToM
  }
}
